import React from 'react';
import PropTypes from 'prop-types';

import { Button, Icon } from 'semantic-ui-react';

const PolicyListAddItem = ({onClick}) => {
    return (
        <Button id="policyAddBtn" onClick={onClick} color="green"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '1.5em', fontSize: '1.2em' }}
        >Add Policy  <Icon name="add square" size="large" style={{ marginLeft: "0.5em", marginRight: 0 }} /></Button>
    );
};

PolicyListAddItem.propTypes = {
    onClick: PropTypes.func,
};

export default PolicyListAddItem;